<template>
  <div class="legend">
    <div v-if="isExtraShow" class="legend-content">
      <p v-for="item in extraLegendList" :key="item.name">
        <img :src="item.img" alt="" :class="item.class" />&nbsp;<span
          class="legend-content__title"
          >{{ item.name }}</span
        >
      </p>
    </div>
    <div class="legend-content">
      <p v-for="item in legendList" :key="item.name">
        <img :src="item.img" alt="" :class="item.class" />&nbsp;<span
          class="legend-content__title"
          >{{ item.name }}</span
        >
      </p>
      <div v-if="isOpsShow">
        <p v-for="item in opsLegendList" :key="item.name">
          <img :src="item.img" alt="" :class="item.class" />&nbsp;<span
            class="legend-content__title"
            >{{ item.name }}</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const legendList = [
  {
    name: "微站",
    img: "static/images/微站.png",
    class: "legend-content__img2"
  },
  {
    name: "标站",
    img: "static/images/标站.png",
    class: "legend-content__img3"
  },
  {
    name: "无人船",
    img: "static/images/无人船.png",
    class: "legend-content__img1"
  },
  {
    name: "无人机",
    img: "static/images/无人机.png",
    class: "legend-content__img1"
  },
  {
    name: "污染源",
    img: "static/images/changsuoxuncha.png",
    class: "legend-content__img1"
  }
];
const extraLegendList = [
  {
    name: "声呐",
    img: "static/images/声呐.png",
    class: "legend-content__img1"
  },
  {
    name: "ADCP",
    img: "static/images/ADCP.png",
    class: "legend-content__img1"
  },
  {
    name: "正摄图",
    img: "static/images/正摄图.png",
    class: "legend-content__img1"
  },
  {
    name: "手机照片",
    img: "static/images/手机照片.png",
    class: "legend-content__img1"
  }
];
const opsLegendList = [
  {
    name: "溯源设备",
    img: "static/images/溯源设备.png",
    class: "legend-content__img4"
  },
  {
    name: "运维中",
    img: "static/images/运维.png",
    class: "legend-content__img4"
  }
];
export default {
  data() {
    return {
      legendList,
      extraLegendList,
      opsLegendList
    };
  },
  props: {
    isExtraShow: {
      type: Boolean,
      default: false
    },
    isOpsShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["userMenuPower"])
  },
  mounted() {
    if (this.userMenuPower.controls.isHideGfStation) {
      this.legendList = this.legendList.filter(item => item.name !== "标站");
    }
  }
};
</script>

<style lang="less" scoped>
.legend {
  position: absolute;
  bottom: 72px;
  right: 20px;
  background: #fff;
  border: 1px solid #ccc;
}
.legend-content {
  border: 1px solid #ccc;
  padding: 4px 10px;
}
.legend-content__img1 {
  height: 26px;
  width: 20px;
}
.legend-content__img2 {
  height: 12px;
  width: 20px;
}
.legend-content__img3 {
  height: 20px;
  width: 20px;
}
.legend-content__img4 {
  height: 18px;
  width: 18px;
}
.legend-content__title {
  height: 20px;
  font-size: 14px;
}
p {
  margin-bottom: 8px;
}
</style>
